import { useAnalytics } from '@contexts/AnalyticsContext'
import { ProductType, productTypeMeta } from '@models/Product'
import { Segmented } from 'antd'
import { useEffect } from 'react'

interface Props {
  defaultValue?: ProductType
  showOnlyTypes?: ProductType[]
}

const AnalyticsProduct = ({
  defaultValue = ProductType.All,
  showOnlyTypes,
}: Props) => {
  const { updateSelectedProduct, selectedProduct } = useAnalytics()

  useEffect(() => {
    updateSelectedProduct(defaultValue)
  }, [])

  return (
    <Segmented
      defaultValue={defaultValue}
      value={selectedProduct}
      options={Object.values(ProductType)
        .map((type) =>
          showOnlyTypes && !showOnlyTypes.includes(type)
            ? null
            : {
                label: productTypeMeta[type].name,
                value: type,
              }
        )
        .filter((e) => e !== null)}
      onChange={(e) => {
        updateSelectedProduct(e)
      }}
    />
  )
}

type AnalyticsProductType = { Product: typeof AnalyticsProduct }

export { AnalyticsProduct, type AnalyticsProductType }
